import { Component, OnInit } from '@angular/core';
import { Idle } from '@ng-idle/core';

@Component({
  selector: 'app-session-timeout-placeholder',
  templateUrl: './session-timeout-placeholder.component.html',
  styleUrls: ['./session-timeout-placeholder.component.scss']
})
export class SessionTimeoutPlaceholderComponent implements OnInit {
  constructor(private idle: Idle) {}

  ngOnInit(): void {
    this.idle.stop();
  }
}
